<template>
  <section id="chatWidget" class="chat-host-wrapper">
    <!-- Chat button (lower right) -->
    <chat-button @showChatChannels="showChatChannels" />
    <!-- Chat Channel list (after clicking button) -->
    <chat-channels
      v-show="isChannels"
      class="chat-host-channels"
      @showMessages="showMessages"
      @recycle="recycle"
      @closeChannels="closeChannels"
      @showNew="showNew"
    />
    <!-- Chat Session & Messages (after clicking a channel from the list) -->
    <chat-messages
      v-show="isChat"
      :channelUrl="channelUrl"
      ref="chatMessages"
      class="chat-host-chat"
      @closeMessages="closeMessages"
      @minimizeMessages="minimizeMessages"
      @editMembers="editMembers"
      @trashed="trashed"
      @showManage="showManage"
      @showMembers="editMembers"
      @upload="upload"
    />
    <!-- New Chat Session generation -->
    <chat-new v-show="isNewChat" class="chat-host-members" @closeNew="closeNew" @sent="sentNew" />
    <!-- Viewing Chat Members -->
    <chat-members v-show="isChatMembers" ref="chatMembers" class="chat-host-members" @closeMembers="closeMembers" @updated="updatedMembers" />
    <!-- Chat Bar (along the bottom and after minimizing a Chat Session) -->
    <chat-bar @showMessages="showMessages" />
    <chat-manage v-show="isChatManagement" ref="chatManagement" class="chat-host-newchat" @closeManagement="closeManagement" />
    <chat-upload v-if="isFileUpload" ref="chatUpload" class="chat-file-upload" :style="uploadPos" @uploaded="uploaded" @closeUpload="closeUpload" />
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ChatButton from '@/components/chat/elements/chat-button.vue'
import ChatChannels from '@/components/chat/elements/chat-groups.vue'
import ChatMessages from '@/components/chat/elements/chat-messages.vue'
import ChatNew from '@/components/chat/elements/chat-new.vue'
import ChatManage from '@/components/chat/elements/chat-manage.vue'
import ChatMembers from '@/components/chat/elements/chat-members.vue'
import ChatBar from '@/components/chat/elements/chat-bar.vue'
import ChatUpload from '@/components/chat/elements/chat-upload.vue'
export default {
  name: 'chat-host',
  components: {
    ChatButton,
    ChatChannels,
    ChatMessages,
    ChatNew,
    ChatManage,
    ChatMembers,
    ChatBar,
    ChatUpload
  },
  data() {
    return {
      isChat: false,
      isChannels: false,
      isNewChat: false,
      isChatMembers: false,
      isChatManagement: false,
      isShowMembers: false,
      isFileUpload: false,
      channelUrl: null,
      channelType: null,
      uploadPos: null
    }
  },
  mounted() {
    this.isChat = false
    this.isChannels = false
    this.isNewChat = false
    this.isShowMembers = false
    this.isFileUpload = false
    this.channelUrl = null
    this.$eventBus.$on('div-moved', this.divMoved)
    console.log('Chat Host: Initializing Chat Host')
    if (window.sendbird === null || window.sendbird === undefined) {
      this.initChat()
    }
  },
  computed: {
    ...mapGetters('auth', ['profile']),
    ...mapGetters('chat', ['channels', 'channelInfo'])
  },
  methods: {
    ...mapActions('chat', [
      'initChat',
      'getChannels',
      'resetMessages',
      'resetChannelInfo',
      'getChannelMessages',
      'quitChat',
      'setChatBar',
      'getUnread'
    ]),
    async init() {},
    closeChannels() {
      this.isChannels = false
    },
    async closeMessages() {
      // remove from Chat Bar
      let data = {
        name: 'remove',
        value: this.channelUrl,
        type: this.channelType
      }
      this.setChatBar(data)
      this.isChat = false
      this.isFileUpload = false
      this.channelUrl = null
      this.isChannels = true
      this.resetChannelInfo()
      await this.recycle()
    },
    closeNew() {
      this.isNewChat = false
      this.isChannels = true
    },
    closeMembers() {
      this.isChatMembers = false
      this.isFileUpload = false
      this.isChat = true
    },
    closeUpload() {
      this.isFileUpload = false
    },
    uploaded(data) {
      console.log('File Uploaded', data)
      this.$refs.chatMessages.createUploadMessage(data)
    },
    async updatedMembers() {
      this.closeMembers()
      await this.getChannelMessages(this.channelInfo)
    },
    closeManagement() {
      this.isChatManagement = false
      this.isChannels = true
    },
    upload() {
      this.isFileUpload = !this.isFileUpload
    },
    divMoved() {
      if (this.isChat) {
        const rec = this.$refs.chatMessages.$el.getBoundingClientRect()
        this.uploadPos = `right: ${window.innerWidth - (rec.left + 18)}px; bottom: ${window.innerHeight - rec.bottom}px;`
      }
    },
    async trashed() {
      this.isChat = false
      this.isFileUpload = false
      this.isNewChat = false
      this.isChannels = true
      await this.recycle()
    },
    minimizeMessages() {
      // add to Chat Bar
      let data = {
        name: 'add',
        value: this.channelUrl,
        type: this.channelType
      }
      this.setChatBar(data)
      this.isChat = false
      this.isFileUpload = false
      this.channelUrl = null
      this.isChannels = true
      this.resetChannelInfo()
    },
    async showChatChannels() {
      if (this.isChat) {
        this.isChat = false
        this.isFileUpload = false
        this.isChannels = false
        this.isNewChat = false
        this.isChatManagement = false
      } else {
        if (window.sendbird) {
          this.isChannels = !this.isChannels
          if (this.isChannels) {
            console.log('Chat Widget: Load Chat Channels', this.isChannels)
            await this.getChannels()
          }
        } else {
          console.log('Sendbird', window.sendbird)
        }
      }
    },
    async recycle() {
      await this.getChannels()
    },
    async showMessages(data) {
      if (this.isChat && this.channelUrl === data.url) {
        this.isChat = false
        this.isFileUpload = false
        this.channelUrl = null
        this.isChannels = true
        this.resetChannelInfo()
      } else {
        this.resetMessages()
        this.isChannels = false
        this.isNewChat = false
        this.isChatMembers = false
        this.isChatManagement = false
        this.channelUrl = data.url
        this.channelType = data.type
        console.log('Show Messages', data)
        await this.getChannelMessages(data)
        this.isChat = true
      }
    },
    async showManage() {
      await this.$refs.chatManagement.init()
      this.isChannels = false
      this.isChat = false
      this.isFileUpload = false
      this.isNewChat = false
      this.isChatMembers = false
      this.isChatManagement = true
    },
    showMembers(show) {
      console.log('Show Members', show)
      this.isShowMembers = show
    },
    showNew() {
      this.resetMessages()
      this.resetChannelInfo()
      this.isChannels = false
      this.isChat = false
      this.isFileUpload = false
      this.isNewChat = true
      this.isChatMembers = false
      this.isChatManagement = false
    },
    async sentNew(channel) {
      this.isChat = false
      this.isFileUpload = false
      this.isNewChat = false
      // console.log('A New Channel Created', channel)
      if (channel) {
        let members = []
        channel.members.forEach(member => {
          members.push({
            name: member.nickname,
            userId: member.userId,
            metadata: member.metaData,
            lastSeenAt: member.lastSeenAt,
            isActive: member.isActive,
            connectionStatus: member.connectionStatus,
            state: member.state
          })
        })
        let data = {
          createdOn: channel.createdAt,
          data: '',
          memberCount: channel.memberCount,
          members: members,
          metadata: {},
          name: channel.name,
          owner: this.profile.guid,
          type: channel.customType,
          unreadCount: 0,
          url: channel.url
        }
        await this.showMessages(data)
      } else {
        await this.showChatChannels()
      }
    },
    editMembers() {
      this.isChannels = false
      this.isChat = false
      this.isFileUpload = false
      this.isNewChat = false
      this.isChatMembers = true
      this.isChatManagement = false
      this.$refs.chatMembers.init()
    }
  },
  beforeDestroy() {
    this.$eventBus.$off('div-moved')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/chat/elements/chat-host.vue